module.exports = __webpack_public_path__ + "images/7cc1cf863d2f4753e42bc68e28ac6e1d.png";